<template>
  <div v-if="this.params.data" style="width: fit-content;">
    <FontAwesomeIcon
      v-if="this.params.value"
      class="mx-1"
      icon="fa-solid fa-circle-exclamation"
      style="cursor:pointer;color:red"
    />
    <span v-if="this.params.value && this.params.value.length">
      Für folgende Jahre gibt es Zeiteinträge ohne Auftragsjahr:
      <span v-for="(e, index) in this.params.value" :key="index">
        <span v-if="index != 0">, </span>{{ e.Year }}
      </span>
    </span>
  </div>
</template>

<script>

</script>